module.exports = __webpack_public_path__ + "img/order.93f4aa25.svg";